import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingofBags = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for bag printing?", 
            answer: "Printingy offers extensive customisation options for bag printing services, including sizes, materials, and styles. Our custom bag design and print services allow you to incorporate logos, colours, and branding elements that align with your identity. Whether you need reusable fabric bags or custom paper bag printing, we ensure the design meets your requirements."
        },
        { 
            question: "Does Printingy handle bulk orders for bag printing?", 
            answer: "Yes, Printingy specialises in bulk bag printing services, catering to businesses with large-scale needs. Bulk printing ensures consistent quality and cost-effective production, making it ideal for retail stores, event promotions, and corporate gifting. Our efficient processes and advanced technology guarantee timely delivery for all bulk orders."
        },
        { 
            question: "What industries benefit from custom bag printing services?", 
            answer: "Custom bag printing services are widely used across retail, hospitality, events, and corporate environments. Retailers use custom paper bag printing for packaging, while event organisers use branded bags for promotional giveaways. Printingy tailors its solutions to meet the unique needs of each industry, ensuring impactful results."
        },
        { 
            question: "What materials and finishes are available for custom bags?", 
            answer: "We use high-quality materials for custom bag design and print, including paper, fabric, and eco-friendly options. Finishes such as matte, glossy, or UV coating enhance your bags' durability and visual appeal. These materials ensure your printed bags maintain a professional appearance while withstanding everyday use."
        },
        { 
            question: "Does Printingy provide design assistance for custom bags?", 
            answer: "Yes, our custom bag design and print services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to produce engaging and functional layouts. From selecting fonts to arranging graphics, we ensure your bags align with your branding and purpose."
        },
        { 
            question: "What is the typical turnaround time for bag printing?", 
            answer: "Turnaround times for bag printing services depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
        },
        { 
            question: "Are eco-friendly options available for custom bags?", 
            answer: "Yes, Printingy is committed to sustainability and offers eco-friendly custom paper bag printing options. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for businesses aligning their branding with eco-conscious values."
        },
        { 
            question: "What factors should I consider when ordering custom bags?", 
            answer: "Consider the purpose, target audience, and distribution method when ordering custom bag designs and prints. Choosing the right material, size, and design elements ensures your bags are effective and visually appealing. Printingy’s team guides the process to help you create products that achieve your marketing or packaging goals."
        },
        { 
            question: "How do I place an order for bag printing services?", 
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for bag printing services. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
        },
        { 
            question: "What makes bulk bag printing cost-effective?", 
            answer: "Bulk bag printing reduces per-unit costs, making it an economical choice for large-scale needs. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk bag printing services ensure exceptional value while maintaining professional standards."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Bags');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes
    
    
  return (
    <div>
    <MetaManager 
  title="Custom Bag Printing and Design Services"
  description="Professional bag printing services for businesses. Bulk custom bag design and print solutions, including custom paper bag printing."
  keywords="Banners, Signs, & Posters Prints,
Flex printing banner design,
Poster Printing Personalized,
Banners and signs,
Custom Banners Printing and Design
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Bag Printing Services</h1>
              <h2 className="text-muted">Custom bag design and print for branding and packaging</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Bags are essential tools for branding and packaging, offering businesses a practical yet impactful way to promote their identity. Printingy specialises in bag printing services, providing tailored solutions for companies across industries. Our offerings include custom bag design and print services, ensuring your branding is represented clearly and professionally.</p>
          <p>We also offer custom paper bag printing for eco-conscious businesses looking for sustainable packaging options. With various sizes, designs, and finishes, our bags are suitable for retail, events, corporate gifting, and more. Whether for product packaging or promotional campaigns, Printingy delivers premium-quality bags to enhance your brand’s visibility.</p>
          <p>With our bulk printing options and advanced printing technology, Printingy ensures consistent quality, timely delivery, and cost-effective solutions for all your bag printing needs.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Bag Printing Solutions</h2>
                <h3 className="large-hed">High-quality, affordable, and eco-friendly bag printing services</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert custom bag design and print services tailored to your branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and professional custom paper bag printing solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing options for cost-effective packaging and promotional needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials, including recyclable and reusable paper bags.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Premium finishes such as matte, glossy, or textured options.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for sharp designs and vibrant colours.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fast turnarounds with efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by retail stores, event organisers, and corporate businesses nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/professionalprints.jpg" // Path relative to the public folder
                  alt="Personalized poster printing for businesses"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Custom Bags Delivered On Time </h2>
            <h3 className="small-hed">Focus on your business while we handle your bag printing needs</h3>
            <p>At Printingy, we combine advanced printing technology and expert craftsmanship to deliver exceptional bag printing services. Whether you need custom bag design and print for promotional events or bulk orders for retail packaging, we ensure precision and consistency in every print.</p>
            <p>Our commitment to quality and efficiency guarantees timely delivery, ensuring your bags are ready to enhance your brand’s visibility when needed. Partner with Printingy for professional bag printing solutions that stand out.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingofBags;
